import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import { FaqSection, RankingSection, MediaSection } from './components/SectionsA';
import { AppSection, FeaturesSection, CardsSection } from './components/SectionsB';
import { TopicsSection, CarouselSection, CommentsSection } from './components/SectionsC';
import { UpdatesSection, IndexSection, ContactSection, AboutSection } from './components/SectionsD';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <RankingSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <CommentsSection />
        <UpdatesSection />
        <IndexSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}